import * as React from 'react';
import {
  List,
  ListProps,
  Datagrid,
  TextField,
  useRecordContext,
  FieldProps,
  useTranslate,
} from 'react-admin';
import Paginator from '../../../components/Paginator';
import { TESTS_PER_PAGE } from '../../../constants/pagination';

import './styles.scss';

const StepField = ({ label: _label }: FieldProps) => {
  const translate = useTranslate();
  const record = useRecordContext();
  const stepId = record?.activeStepId;
  const displayValue = stepId ? translate(`treatments.steps.${stepId}`) : '';

  return <span>{displayValue}</span>;
};

const TreatmentsDatagrid = () => (
  <Datagrid rowClick="show">
    <StepField label="Step" source="activeStepId" />
    <TextField source="userName" label="Name" />
  </Datagrid>
);

const TreatmentsList = (props: ListProps) => (
  <List
    {...props}
    bulkActionButtons={false}
    actions={false}
    pagination={<Paginator perPage={TESTS_PER_PAGE} />}
    perPage={TESTS_PER_PAGE}
  >
    <TreatmentsDatagrid />
  </List>
);

export default TreatmentsList;
